export default {
  data: () => ({
    dataArray: [],
    dataString: [],
    total1: 0,
    total2: 0,
    spreadsheetData: [],
    sheetData: [
      ["Mazda", "curr", 2001, 2000],
      ["Mazda", "prev", 2020, 2020],
      ["Pegeout", "curr", 2010, 5000],
      ["Pegeout", "prev", 2020, 2020],
      ["Honda Fit", 2009, 3000],
      ["Honda CRV", 2010, 6000],
    ],
    monthTableRawData: [],
    monthTableHeader: [
      {
        text: "Item",
        value: "name",
        sortable: true,
        align: "left",
      },
      {
        text: "",
        align: "right",
      },
      {
        text: "Jan",
        align: "right",
      },
      {
        text: "Feb",
        align: "right",
      },
      {
        text: "Mar",
        align: "right",
      },
      {
        text: "Apr",
        align: "right",
      },
      {
        text: "May",
        align: "right",
      },
      {
        text: "Jun",
        align: "right",
      },
      {
        text: "Jul",
        align: "right",
      },
      {
        text: "Aug",
        align: "right",
      },
      {
        text: "Sep",
        align: "right",
      },
      {
        text: "Oct",
        align: "right",
      },
      {
        text: "Nov",
        align: "right",
      },
      {
        text: "Dec",
        align: "right",
      },
    ],
    monthTableData: [],
    chartTypeArray: ["bar", "line", "table", "cards"],
    chartType: "bar",
    tabChange: 0,
    chartQueryResponse: [],
    selectedTableDimension: "",
    selectedTableDimensionName: "",
    tableDimensionData: [
      { name: "Areas", dataIndex: 6, schemaName: "area" },
      { name: "Visits", dataIndex: 1, schemaName: "visit" },
      { name: "Product Categories", dataIndex: 3, schemaName: "category" },
      { name: "Brands", dataIndex: 4, schemaName: "brand" },
      { name: "Customer Categories", dataIndex: 0, schemaName: "custcat" },
      { name: "Customer Group", dataIndex: 1, schemaName: "custgroup" },
    ],
    selectedTableItems: [],
    prodCatLineLabels: [],
    prodCatLineData1: [],
    prodCatLineData2: [],
    tabledata: [],
    actualVisitsData: [],
    planVisitsData: [],
    visitPerDay: "",
    planVisit: "",
    currVisit: "",
    prevVisit: "",
    prevMthVisit: "",
    projectedVisit: "",
    currAMT: "",
    prevAMT: "",
    prevMthAMT: "",
    projectedAMT: "",
    currMT: "",
    prevMT: "",
    prevMthMT: "",
    projectedMT: "",
  }),
};
